import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SubstationTemplateDto } from 'shared-lib';

// "SELECT ASSET / template / substation" picker shown in the schematic header; the host loads and filters the lists.
@Component({
  selector: 'app-schema-asset-picker',
  templateUrl: './schema-asset-picker.component.html',
  styleUrls: ['./schema-asset-picker.component.scss'],
  standalone: false,
})
export class SchemaAssetPickerComponent implements OnChanges {
  @Input() templates: SubstationTemplateDto[] = [];
  @Input() substations: any[] = [];
  @Input() selectedTemplate: SubstationTemplateDto | null = null;
  @Input() selectedSubstation: any | null = null;
  @Output() templateSelected = new EventEmitter<SubstationTemplateDto>();
  @Output() substationSelected = new EventEmitter<any>();
  @Output() searchChange = new EventEmitter<string>();

  openMenu: 'template' | 'substation' | null = null;
  searchTerm = '';

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTemplate']) this.searchTerm = '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.openMenu && !this.elementRef.nativeElement.contains(event.target as Node)) this.openMenu = null;
  }

  toggleMenu(menu: 'template' | 'substation'): void {
    if (menu === 'substation' && !this.selectedTemplate) return;
    this.openMenu = this.openMenu === menu ? null : menu;
  }

  onSearchChange(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.searchChange.emit(searchTerm);
  }

  selectTemplate(template: SubstationTemplateDto): void {
    this.openMenu = null;
    if (template.id !== this.selectedTemplate?.id) this.templateSelected.emit(template);
  }

  selectSubstation(substation: any): void {
    this.openMenu = null;
    if (substation.id !== this.selectedSubstation?.id) this.substationSelected.emit(substation);
  }
}
